/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import SubscriptionLanguageModel from 'cio/models/subscription-language';

interface TableArgs {
  languages: SubscriptionLanguageModel[];
  readOnly: boolean;
  searchValue: string;
  languageChecked: () => unknown;
  selectAllLanguagesOnPage: () => unknown;
  selectedLanguages: SubscriptionLanguageModel[];
  allSelected: boolean;
  allLanguagesOnPageIndeterminate: boolean;
}

export default class Table extends Component<TableArgs> {}
